// @ts-check
import { useState } from 'react';
import {
  StyledActionsContainer,
  StyledHeader,
  StyledIcon,
  StyledReportedMetricsModal,
  StyledSeparator
} from './ReportedMetricsModal.style';

import { useReportedMetricsModal } from './useReportedMetricsModal';
import { ReportedMetricSelector } from './ReportedMetricSelector';
import { AggregationSelector } from './AggregationSelector';
import { DistinctCountSelector } from './DistinctCountSelector';
import { MetricNameInput } from './MetricNameInput';
import { useDispatch } from 'react-redux';
import { toggleModal } from 'state/callers';
import LoadingMetricsState from './LoadingMetricsState';
import UnitInput from './UnitInput';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { LBButton } from '@linearb/buzz';

export const ReportedMetricsModal = ({ widget, onChange }) => {
  const dispatch = useDispatch();
  const { filters = {} } = widget;
  const [modalState, setModalState] = useState({
    metricName: widget?.name || '',
    aggregation: filters.agg || '',
    distinctCount: filters.distinct_count || null,
    reportedMetric: widget.metrics[0]?.name || null,
    unit: filters.unit || ''
  });

  const {
    metrics = {},
    isSaveEnabled,
    isLoadingMetrics
  } = useReportedMetricsModal();

  const handleSave = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.METRICS,
      page_tab: TRACKING.PAGE_TABS.CUSTOM_METRICS,
      click_type: TRACKING.CLICK.SAVE,
      metric_name: modalState.metricName
    });
    onChange(
      {
        ...widget,
        metrics: [{ name: modalState.reportedMetric }],
        name: modalState.metricName,
        filters: {
          ...widget.filters,
          agg: modalState.aggregation,
          distinct_count: modalState.distinctCount,
          unit: modalState.unit
        }
      },
      false
    );
    toggleModal()(dispatch);
  };

  // @ts-ignore
  const selectedMetric = (metrics?.data || []).find(
    ({ metric_name }) => metric_name === modalState.reportedMetric
  );

  return (
    <StyledReportedMetricsModal>
      <StyledHeader items='center'>
        <StyledIcon name='Settings' />
        Reported Metric
      </StyledHeader>
      <StyledSeparator />
      {isLoadingMetrics ? (
        <LoadingMetricsState />
      ) : (
        <>
          <div className='flex flex-col'>
            <MetricNameInput
              modalState={modalState}
              setModalState={setModalState}
            />
            <ReportedMetricSelector
              modalState={modalState}
              setModalState={setModalState}
              metrics={metrics}
            />
            <UnitInput modalState={modalState} setModalState={setModalState} />
            <AggregationSelector
              modalState={modalState}
              setModalState={setModalState}
            />
            <DistinctCountSelector
              modalState={modalState}
              setModalState={setModalState}
              selectedMetric={selectedMetric}
            />
          </div>
          <StyledActionsContainer>
            <LBButton
              onClick={handleSave}
              disabled={!isSaveEnabled(modalState)}
            >
              Save
            </LBButton>
          </StyledActionsContainer>
        </>
      )}
    </StyledReportedMetricsModal>
  );
};
